import React from 'react'
import { PaymentSummaryType } from '../types'
import { NotAvailableIcon, TriangleIcon, TrophyIcon } from 'assets'
import { colors } from 'styles/colors'
import CircularProgressBar from 'components/circularProgressBar/CircularProgressBar'
import { numberFormatter } from 'helpers'

const finishedTrophyIcon = (
    <TrophyIcon color={colors.white} width="35" height="35" />
)

export const ActiveClientProgress = ({
    paymentSummary: {
        allEnrollment,
        formattedAllEnrollment,
        balance,
        formattedBalance,
        percentage,
        paymentLeft,
        formattedPaymentLeft
    },
    isAnyDelivered,
    showMilestones = false
}: {
    paymentSummary: PaymentSummaryType
    isAnyDelivered?: boolean
    showMilestones?: boolean
}) => {
    if (percentage < 0) {
        return (
            <div className="client-payment--progress-container">
                <div className="client-payment--progress-header client-payment--progress-insufficient">
                    {formattedPaymentLeft}
                    <TriangleIcon color={colors.red} />
                </div>
                <CircularProgressBar
                    percentage={0}
                    incompleteLabel={numberFormatter(allEnrollment, '')}
                    showMilestones={showMilestones}
                />
                <div className="client-payment--progress-negative-balance">
                    <TriangleIcon width="17" height="14" color={colors.red} />
                    {numberFormatter(balance, '')}
                </div>
            </div>
        )
    }
    if (percentage === 0 && !isAnyDelivered) {
        return (
            <div className="client-payment--progress-container">
                <div className="client-payment--progress-header client-payment--progress-not-available">
                    <TrophyIcon color={colors.grey} width="18" height="18" />
                    {formattedAllEnrollment}
                </div>
                <div
                    aria-label="progress-not-available"
                    className="client-payment--progress-bar-not-available"
                >
                    <NotAvailableIcon width="84" height="84" />
                </div>
            </div>
        )
    }
    if (percentage === 100) {
        return (
            <div className="client-payment--progress-container">
                <div className="client-payment--progress-header client-payment--progress-finished">
                    {formattedBalance}
                </div>
                <CircularProgressBar
                    percentage={percentage}
                    centerIconHeight={35}
                    centerIcon={finishedTrophyIcon}
                    gaugeColor={colors.purple}
                    showMilestones={showMilestones}
                />
            </div>
        )
    }
    if (percentage > 100) {
        return (
            <div className="client-payment--progress-container">
                <div className="client-payment--progress-header client-payment--progress-surplus">
                    {formattedBalance}
                    <TriangleIcon />
                </div>
                <CircularProgressBar
                    percentage={percentage}
                    centerIconHeight={35}
                    centerIcon={finishedTrophyIcon}
                    centerLabel={numberFormatter(allEnrollment, '')}
                    gaugeColor={colors.purple}
                    showMilestones={showMilestones}
                />
            </div>
        )
    }
    return (
        <div className="client-payment--progress-container">
            <div className="client-payment--progress-header client-payment--progress-goal">
                <TrophyIcon color={colors.grey} width="18" height="18" />
                {formattedAllEnrollment}
            </div>
            <CircularProgressBar
                percentage={percentage}
                completeLabel={numberFormatter(balance, '')}
                incompleteLabel={numberFormatter(paymentLeft, '')}
                showMilestones={showMilestones}
            />
        </div>
    )
}
